module.exports = __webpack_public_path__ + "static/media/01.895cea91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/01.jpg
// module id = 176
// module chunks = 0